import React from "react";
import type { ViewComponent } from "@frui.ts/views";
import { registerView } from "@frui.ts/views";
import { observer } from "mobx-react-lite";
import ExternalReportsViewModel from "viewModels/timeCharges/reporting/externalReports/externalReportsViewModel";
import Tabs from "../../../common/tabs";

const ExternalReportsView: ViewComponent<ExternalReportsViewModel> = observer(({ vm }) => (
  <>
    <h3 className="mb-4">{vm.name}</h3>
    <Tabs vm={vm} />
  </>
));

registerView(ExternalReportsView, ExternalReportsViewModel);
